import React, { useContext } from 'react';
import { Icon, Drawer } from '@/components';
import { ProductContext } from '.';
import { i18n, priceFormat } from '@/utils';
import styles from './style.less';

interface LetteringProp {
  /** 默认刻字文案 */
  defaultLineText?: string;
  /** 关闭回调 */
  onClose: (isClose?: boolean) => void;
  /** 刻字回调 */
  onAdd: () => void;
}

const Lettering: React.FC<LetteringProp> = ({ defaultLineText, onClose, onAdd }) => {

  const { shop, lineTextsIncrease } = useContext(ProductContext)

  return (
    <div className={styles.lettering}>
      <Drawer
        onClose={onClose}
        mask={false}
        className={styles.content}
      >
        <div className={styles.close} onClick={() => onClose(true)}>
          <Icon type='close' color='#000' size={30} />
        </div>
        <div className={styles.title}>{defaultLineText ? i18n.format('modules.new.sock.add.default.line.text.title') : i18n.format('modules.new.sock.add.line.text.title')}</div>
        <div className={styles.tip}>{i18n.format('modules.new.sock.add.line.text.promotion')}</div>
        <div className={styles.button}>
          <div className={styles.addText} onClick={onAdd}>
            {/* {`${i18n.format('modules.new.sock.add.line.text')} + ${shop.currencySymbol}${lineTextsIncrease?.price}`} */}
            {defaultLineText ? i18n.format('modules.new.sock.custom.name') : `${i18n.format('modules.new.sock.add.line.text')} + ${priceFormat(shop.currencySymbol, lineTextsIncrease!.price)}`}
          </div>
          <div className={styles.withouText} onClick={() => onClose()}>
            {defaultLineText ? i18n.format('modules.new.sock.use.current.name') : i18n.format('modules.new.sock.without.text')}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default Lettering;
